import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-download-limit",
  "use": "icon-download-limit-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-download-limit\"><path d=\"M489.244444 764.776296h409.6c37.736296 0 68.266667 25.41037 68.266667 56.888889s-30.53037 56.888889-68.266667 56.888889H489.244444c-37.736296 0-68.266667-25.41037-68.266666-56.888889 0-31.288889 30.53037-56.888889 68.266666-56.888889zM125.155556 455.111111h773.688888c37.736296 0 68.266667 25.41037 68.266667 56.888889s-30.53037 56.888889-68.266667 56.888889H125.155556C87.419259 568.888889 56.888889 543.478519 56.888889 512s30.53037-56.888889 68.266667-56.888889zM125.155556 145.445926h773.688888c37.736296 0 68.266667 25.41037 68.266667 56.888889s-30.53037 56.888889-68.266667 56.888889H125.155556c-37.736296 0-68.266667-25.41037-68.266667-56.888889s30.53037-56.888889 68.266667-56.888889z\" p-id=\"1178\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/download-limit.svg
// module id = GJ6p
// module chunks = 5